import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { Header } from 'src/app/models/header.model';
import { ActivatedRoute } from '@angular/router';
import { PendingOrdersService } from 'src/app/core/services/pending-orders/pending-orders.service';
import { OIOTAC } from 'src/app/models/oi-ot-ac.model';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { IonContent, ModalController, NavParams } from '@ionic/angular';
import { Skeleton } from 'src/app/models/skeleton.model';
import { NotificationsService } from 'src/app/core/services/notifications/notifications.service';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login/login.service';

@Component({
  selector: 'app-pending-orders-modal',
  templateUrl: './pending-orders-modal.component.html',
  styleUrls: ['./pending-orders-modal.component.scss'],
})
export class PendingOrdersModalComponent implements OnInit {

  public header: Header = {
    title: 'Pendientes',
    icon: 'close-outline',
    principalPage: false,
  }

  public pendings: OIOTAC[] = [];
  public filteredPendings: OIOTAC[] = [];
  public httpError: string = null;
  public unitId;
  private reloadPendingsSubs;

  public skeleton: Skeleton = {
    card: true, show: true
  }
  private connectionSubscription: Subscription;
  public isOnline: Boolean = false;

  @ViewChild(IonContent, { static: false }) content: IonContent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private pendingsService: PendingOrdersService,
    private utils: UtilsService,
    private ngZone: NgZone,
    private notificaions: NotificationsService,
    public modalCtrl: ModalController,
    private navParams: NavParams,
    private networkService: NetworkService,
    private userService: LoginService,
    private translate : TranslateService
  ) {
    this.utils.signedAct.subscribe(() => this.ngOnInit());
    this.reloadPendingsSubs = notificaions.reloadPendings.subscribe(() => this.getPendings())
    this.connectionSubscription = this.networkService.getConnectionStatus()
      .subscribe(data => this.ngZone.run(() => this.isOnline = data));

    this.networkService.getInitialConecctionState().then(data => this.ngZone.run(() => this.isOnline = data))

  }

  async ngOnInit() {
    this.header.title = this.translate.instant('pending-orders-modal.Pendientes');
    this.skeleton.show = true;
    this.getPendings();
  }

  async getPendings(pull?) {

    this.unitId = this.navParams.get('unitId');
    if (this.unitId) {
      const { name, project } = await this.utils.getFromStorage('unitInfo');
      this.header.subtitle = `${name} - ${project}`
      const unit = await this.utils.getFromStorage('unitParams');
      if (this.unitId == unit.selectedUnitId) {
        this.pendingsService.getPendingsByUnit(unit)
          .subscribe((data) => {
            this.manageResponse(data, pull);
          });
      } else
        console.log('error');
    } else {
      let company = null;
      try {
        company = await this.utils.getFromStorage('company');
      } catch (e) {
      } finally {
        this.pendingsService.getAllPendings(company)
          .subscribe((data) => {
            this.manageResponse(data, pull);
          });
      }
    }
  }



  filterByTye({ detail: { value } }) {
    this.filteredPendings = parseInt(value) ? this.pendings.filter((el: OIOTAC) => el.tipo === 'AC') : this.pendings;
  }


  manageResponse({ data, error, operation }: { data: OIOTAC[], error, operation: string }, pull?) {
    if (pull)
      pull.target.complete();
    // this.content.scrollToTop();
    if (error) {
      this.httpError = operation;
      this.utils.showMessage(operation);
      this.skeleton.show = false;
    } else {
      this.httpError = null;
      this.ngZone.run(() => {
        this.pendings = data.sort((a, b) => new Date(this.utils.changeDateSeparator(b.fecha_edicion)).getTime() - new Date(this.utils.changeDateSeparator(a.fecha_edicion)).getTime());
        if (localStorage.getItem('platform') === 'desktop') {
          const withouAnswer = this.pendings.filter(el => el.tipo === 'AC' || (el.estado && el.estado.id === 1));
          const answered = this.pendings.filter(el => el.estado && el.estado.id !== 1);
          this.pendings = [...withouAnswer, ...answered];
        }

        const allCompanies = this.pendings.filter((arr, index, self) =>
          index === self.findIndex((t) => (t.empresa.id === arr.empresa.id)));
        this.getConfig(allCompanies)
        this.filteredPendings = this.pendings;
      });
    }
  }

  async getConfig(allCompanies) {
    if (allCompanies.length) {
      let configPromises = [];
      for (let i = 0; i < allCompanies.length; i++) {
        configPromises.push(this.userService.getUserConfigPromises(allCompanies[i].empresa.id));
      }

      const responses = await Promise.all(configPromises);
      for (let i = 0; i < this.pendings.length; i++) {
        this.pendings[i].timeResponseConfig = responses.find(resp => resp.data.id === this.pendings[i].empresa.id).data.tiempo_respuesta_ordenes_propietarios;
      }
    }
    this.skeleton.show = false;
  }


  ngOnDestroy() {
    this.reloadPendingsSubs.unsubscribe();
    this.connectionSubscription.unsubscribe();
  }
}
